import { getRequest, postRequest, deleteRequest } from "../lib/utils/request";

export const getAllAPI = async (
  apiHost,
  { limit, offset, sortField, sortDir, search },
  requestOptions
) => {
  if (!search.agencyUID) search.agencyUID = "";

  return await getRequest(
    `${apiHost}/v1/offer/all?limit=${limit}&offset=${offset}&sortField=${sortField}&sortDir=${sortDir}&searchGeneral=${
      search.general
    }&searchLocalization=${search.localization}&searchSex=${
      search.sex
    }&agencyUID=${search.agencyUID}`,
    requestOptions
  );
};

export const getAPI = async (apiHost, { slug }, requestOptions) => {
  return await getRequest(`${apiHost}/v1/offer/slug/${slug}`, requestOptions);
};

export const createAPI = async (apiHost, data, requestOptions) => {
  return await postRequest(`${apiHost}/v1/offer/site`, data, requestOptions);
};

export const deleteByKeyAPI = async (apiHost, { key }, requestOptions) => {
  return await deleteRequest(`${apiHost}/v1/offer/key/${key}`, requestOptions);
};



/** WEBPACK FOOTER **
 ** ./src/common/offer/api.js
 **/